import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { Columns } from '../../types/state';
import { FetchColumnsParams } from '../../types/request';

const initialState: Columns = {
  data: [],
  fetchingStatusColumns: false,
  error: null
};

export const columnsVPO = createSlice({
  name: NameSpace.Columns,
  initialState,
  reducers: {
    fetchColumnsRequest: (state, payload: PayloadAction<FetchColumnsParams>) => {
      state.fetchingStatusColumns = true;
      state.error = null;
    },
    fetchColumnsSuccess: (state, action) => {
      state.fetchingStatusColumns = false;
      state.data = action.payload;
    },
    fetchColumnsFailure: (state, action) => {
      state.fetchingStatusColumns = false;
      state.error = action.payload;
    },
  },
});

export const { fetchColumnsRequest, fetchColumnsSuccess, fetchColumnsFailure } = columnsVPO.actions;
